// Settings scopes — the two parallel settings stacks the admin editors serve.
//
// The device/family stack and the igloo stack are structurally identical: a
// global baseline split across two visibility docs, overridden per-entity by an
// admin `overrideSettings` subcollection, with the same per-setting field shape
// (value / type / order / label / choices / range / step / description / tooltip).
// SettingsViewer and OverrideSettingsViewer are therefore ONE implementation
// each, parameterised by one of these descriptors — no component hardcodes a
// Firestore path.
//
// Naming note (CLAUDE.md terminology): the collections are `iglooInfo` /
// `iglooSettings` internally, but everything shown to a human says "Higlo".
//
// Global:   {globalRoot}/{internalDoc | externalDoc}/settings/{category}
// Override: {overrideRoot}/{entityId}/overrideSettings/{category}

export const HEARTH_SCOPE = {
  key: 'hearth',
  globalRoot: 'deviceSettings',
  internalDoc: 'everyFamilyVisible',
  externalDoc: 'everyAccountAndEveryFamilyVisible',
  externalBadge: 'user controllable',
  overrideRoot: 'deviceManagement',
  globalTitle: 'Global Hearth Settings',
  overrideTitle: 'Hearth Override Settings',
  entityLabel: 'Hearth',
  // Copy for the override editor's explanatory paragraph.
  overrideBlurb:
    'Per-Hearth setting overrides (admin-controlled). These sit between the global ' +
    'Hearth settings and any user-controllable overrides. Toggle a setting on to ' +
    'override its global value for this Hearth. Toggle off to remove the override ' +
    'and revert to the global value.',
};

export const IGLOO_SCOPE = {
  key: 'igloo',
  globalRoot: 'iglooSettings',
  internalDoc: 'everyIglooVisible',
  externalDoc: 'everyControllerAndEveryIglooVisible',
  externalBadge: 'controller controllable',
  overrideRoot: 'iglooInfo',
  globalTitle: 'Global Higlo Settings',
  overrideTitle: 'Higlo Override Settings',
  entityLabel: 'Higlo',
  overrideBlurb:
    'Per-Higlo setting overrides (admin-controlled). A Higlo setting applies ' +
    'identically to every Hearth in the Higlo — it cannot be diverged per-Hearth. ' +
    'Toggle a setting on to override its global value for this Higlo. Toggle off ' +
    'to remove the override and revert to the global value. Read each setting’s ' +
    'description: some take effect at the next Higlo entry, and some restart a ' +
    'session that is already running.',
};
